import axios from '../utils/axios';
import { ApiResponseBody, ActiveCard, PayEarlyResult, PaymentHistoryItem, SubscriptionInfo, SubscriptionStatus, UnsubscribeResult } from '../types/subscription';

const unwrapBody = <T,>(response: { data: ApiResponseBody<T> }) => response.data.body;

export const subscriptionApi = {
    getSubscriptionInfo: async () => unwrapBody<SubscriptionInfo>(await axios.get('/api/subscription-info')),
    getSubscriptionStatus: async () => unwrapBody<SubscriptionStatus>(await axios.get('/api/status')),
    getActiveCard: async () => unwrapBody<ActiveCard | null>(await axios.get('/api/active-card')),
    getPaymentHistory: async () => unwrapBody<PaymentHistoryItem[]>(await axios.get('/api/history')),
    unsubscribe: async () => unwrapBody<UnsubscribeResult>(await axios.post('/api/unsubscribe')),
    payEarly: async (invoiceId: string) => unwrapBody<PayEarlyResult>(await axios.post('/api/pay-early', { invoice_id: invoiceId })),
};
